// Remember to check shouldRouterInternally before using this function.
export function pathForInternalLink(basePath: string, path: string): string {
  const internalPath = path.replace(basePath, '');
  const emptyOrOnlyQueryString = /^(\?.+)?$/.test(internalPath);

  return emptyOrOnlyQueryString ? `/${internalPath}` : internalPath;
}
